import createValueModule from "@/redux/create-value-module";

import {
    $WishlistModalModuleName,
    TWishlistModalState
} from "./wishlistModal.types";

const { constants: _constants, actions } =
    createValueModule<TWishlistModalState>($WishlistModalModuleName, {
        visible: false
    });

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
